module.exports = __webpack_public_path__ + "public/media/ITOUCH.png";


//////////////////
// WEBPACK FOOTER
// ./images/partners/lOGO PNG/ITOUCH.png
// module id = ./images/partners/lOGO PNG/ITOUCH.png
// module chunks = 0